import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

class ClientGroupApi {
  getClientGroups = async (params) => {
    try {
      const response = await api.get("/client-group", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Client Groups. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  createClientGroup = async (data) => {
    try {
      const response = await api.post("/client-group", data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Create Client Group. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  updateClientGroup = async (id, data) => {
    try {
      const response = await api.put(`/client-group/${id}`, data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Update Client Group. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  getClientGroupById = async (id) => {
    try {
      const response = await api.get(`/client-group/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Client Group. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  deleteClientGroup = async (id, params) => {
    try {
      const response = await api.delete(`/client-group/${id}`, { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Delete Client Group. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  getClientsInGroup = async (groupId, params) => {
    try {
      const response = await api.get(`/client-group/${groupId}/clients`, { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Clients in Group. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  assignGroupClients = async (groupId, data) => {
    try {
      const response = await api.post(`/client-group/${groupId}/assign-clients`, data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Assign Group Clients. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  assignToOtherManager = async (data) => {
    try {
      const response = await api.post(`/client-group/assign-to-other-manager`, data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Assign Clients to Manager. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };
}

const clientGroupApi = new ClientGroupApi();
export default clientGroupApi;

export const { getClientGroups, createClientGroup, deleteClientGroup, updateClientGroup, getClientGroupById, getClientsInGroup, assignGroupClients, assignToOtherManager } =
  clientGroupApi;
